import * as React from "react";
import { ReactComponent as PlantSvg } from "../media/plant.svg";
import { ReactComponent as SoilSvg } from "../media/soil.svg";
import { ReactComponent as WaterSvg } from "../media/water.svg";
import { ReactComponent as MiscSvg } from "../media/misc.svg";

interface ISampleTypeProps {
  sampleType: string;
  onSampleSelected: (sample: string) => void;
}

export class SampleTypeSelection extends React.Component<ISampleTypeProps, {}> {
  public render() {
    const activeDiv =
      "anlab_form_style anlab_form_samplebtn active-bg flexcol active-border active-svg active-text";
    const inactiveDiv = "anlab_form_style anlab_form_samplebtn flexcol";
    return (
      <div>
        <div className="flexrow">
          <div
            className={
              this.props.sampleType === "Soil" ? activeDiv : inactiveDiv
            }
            onClick={() => this._handleChange("Soil")}
          >
            <SoilSvg />
            <h3>Soil Only</h3>
          </div>
          <div
            className={
              this.props.sampleType === "Plant" ? activeDiv : inactiveDiv
            }
            onClick={() => this._handleChange("Plant")}
          >
            <PlantSvg />
            <h3>Plant / Feed Only</h3>
          </div>
          <div
            className={
              this.props.sampleType === "Water" ? activeDiv : inactiveDiv
            }
            onClick={() => this._handleChange("Water")}
          >
            <WaterSvg />
            <h3>Water and Irrigation Water Only</h3>
          </div>
          <div
            className={
              this.props.sampleType === "Miscellaneous"
                ? activeDiv
                : inactiveDiv
            }
            onClick={() => this._handleChange("Miscellaneous")}
          >
            <MiscSvg />
            <h3>Misc & Specialty Testing</h3>
          </div>
        </div>
        {this.props.sampleType && this.props.sampleType !== "Water" && (
          <div className="alert alert-info" role="alert">
            Unless requested, all samples will be analyzed on dry material.
          </div>
        )}
      </div>
    );
  }

  private _handleChange = (sampleType: string) => {
    this.props.onSampleSelected(sampleType);
  };
}
